import * as React from "react";

import { ReactComponent as CheckmarkIcon } from "../icons/card/checkmark.svg";
import { exercisesConfig } from "../../constants/exercises";

import styles from "./select-lifts.module.css";

interface IProps {
  onChange?: (selectedLifts: string[]) => void;
  initialValues?: string[];
}

export default function SelectLifts({ onChange, initialValues }: IProps) {
  const exercises = exercisesConfig.filter(exercises => exercises.mandatory);

  const [selectedLifts, setSelectedLifts] = React.useState<string[]>(
    initialValues || []
  );
  const [lifts, setLifts] = React.useState(exercises);
  const [isButtonShown, setIsButtonShown] = React.useState(true);

  const isChecked = (id: string) =>
    selectedLifts.some(selectedLift => selectedLift === id);

  const onChangeSelectedList = (id: string) => {
    const exists = isChecked(id);
    let result: string[];
    if (exists) {
      result = selectedLifts.filter(
        (selectedLift: string) => id !== selectedLift
      );
      setSelectedLifts(result);
    } else {
      result = [...selectedLifts, id];
      setSelectedLifts(result);
    }
    if (onChange) {
      onChange(result);
    }
  };

  const onClickAdvancedListButton = () => {
    setLifts(exercisesConfig);
    setIsButtonShown(false);
  };
  return (
    <>
      {lifts.map(lift => (
        <div
          key={lift.id}
          className={styles.selectBlock}
          onClick={() => onChangeSelectedList(lift.id)}
        >
          <div className={styles.icon}>
            {lift.title}
            {isChecked(lift.id) && <CheckmarkIcon className={styles.check} />}
          </div>
        </div>
      ))}
      {isButtonShown && (
        <div className={styles.advanced}>
          <button className={styles.silver} onClick={onClickAdvancedListButton}>
            View Advanced List
          </button>
        </div>
      )}
    </>
  );
}
